module.exports = __webpack_public_path__ + "img/ohaus-north-shore.c3c44cc5.jpg";